import React from 'react'
import { Card } from 'antd'
import { PromptStyle } from '@pushly/models/lib/enums'
import { FormLayoutRow, Well } from '@pushly/aqe/lib/components'
import classNames from 'classnames'

type PromptTreatmentStyleSelectorProps = {
    loading?: boolean
    value?: PromptStyle
    onChange: (value: PromptStyle) => void
}

const DEFAULT_PROMPT_STYLE = PromptStyle.NATIVE

export const PromptStyleSelector: React.FC<PromptTreatmentStyleSelectorProps> = ({ loading, value, onChange }) => {
    const options: { value: PromptStyle; label: string }[] = [
        { value: PromptStyle.NATIVE, label: 'System Prompt' },
        { value: PromptStyle.SLIDE, label: 'Slide Prompt' },
        { value: PromptStyle.PUBLISHER_CUSTOM, label: 'Custom Prompt' },
    ]

    const selected = value ?? DEFAULT_PROMPT_STYLE

    return (
        <Well title="Style" hideFooter={true} mode="ghost">
            <FormLayoutRow
                className="prompt-style-selector"
                loading={loading}
                skeleton={{ width: 420 }}
                layout="vertical"
                label={null}
                value={
                    <div className="prompt-style-options">
                        {options.map((opt) => {
                            const optClassNames: string[] = [`prompt-style-${opt.value.toLowerCase()}`]

                            if (opt.value === selected) {
                                optClassNames.push('selected')
                            }

                            return (
                                <div key={opt.value} onClick={() => onChange(opt.value)}>
                                    <Card className={classNames(optClassNames)}>
                                        <Card.Meta title={opt.label} />
                                    </Card>
                                </div>
                            )
                        })}
                    </div>
                }
            />
        </Well>
    )
}
